import RegionSelect from '../pages/RegionSelect'
import ProductOverview from '../pages/ProductOverview'
import ProductSelection from '../pages/ProductSelection'
import Payment from '../pages/Payment'
import Cart from '../pages/Cart'
import StoreUserLogin from '../pages/StoreUserLogin'
import StoreUserChangePassword from '../pages/StoreUserChangePassword'
import PaymentSelection from '../pages/PaymentSelection'
import PaymentStatus from '../pages/PaymentStatus'
import PaymentConfirmation from '../pages/PaymentConfirmation'
import CancelSubscriptionReminders from '../pages/CancelSubscriptionReminders'
import SpecialSale from '../pages/SpecialSale'
import { overrideFromWebsiteCookie } from '../website-integration/region-manager'
import type Store from 'vuex'
import SubscriptionManager from '../subscription/subscription-manager'
import buildAbtRoutes from './abt'
import Offline from '../components/Offline'
import axios from 'axios'
import Vue from 'vue'

export default async function buildRoutes (store: Store, subscriptionManager: SubscriptionManager) {
  let offline = false
  try {
    const result = await axios({
      method: 'GET',
      'url': Vue.prototype.$container.config.assistApiUrl + '/content/offline'
    })
    const data = result.data
    if (typeof data === 'object' && data.content !== '') {
      offline = data
    }
  } catch (e) {
    // No action needed, because when this happens the order api might be broken or not updated yet and the unbroken parts of the webshop still have to be reachable
  }
  if (offline) {
    const arr = [
      {
        path: '/*',
        name: 'Offline',
        component: Offline,
        props: {data: offline}
      }
    ]
    return arr
  }
  return [
    {
      path: '/:lang/webshop/product-selection/select-region',
      name: 'RegionSelect',
      component: RegionSelect,
      beforeEnter: async function (to, from, next) {
        const regionOverriddenFromWebsite = await overrideFromWebsiteCookie()
        if (regionOverriddenFromWebsite && store.getters['selection/availableSelectedRegions'].length > 0) {
          next({name: 'ProductOverview', params: to.params})
        } else {
          next()
        }
      }
    },
    {
      path: '/:lang/webshop/product-selection/renew-subscription/subscription/:token',
      name: 'SubscriptionRenewal',
      beforeEnter: async (to, from, next) => {
        await store.dispatch('selection/fetchFilters')
        const destination = await {
          name: 'ProductOverview',
          params: to.params,
          query: await subscriptionManager.buildSubscriptionRenewalDeeplinkParameters(to.params.token)
        }
        next(destination)
      }
    },
    {
      path: '/:lang/webshop/product-selection/cancel-subscription-reminders/subscription/:token',
      name: 'CancelSubscriptionReminders',
      component: CancelSubscriptionReminders
    },
    {
      path: '/:lang/webshop/product-selection/overview',
      name: 'ProductOverview',
      component: ProductOverview,
      beforeEnter: (to, from, next) => {
        overrideFromWebsiteCookie() // this method is async, but we do not need to wait for it to finish
        next()
      }
    },
    {
      path: '/catalogus',
      redirect: {name: 'ProductSelectionIndex', params: {lang: 'nl'}}
    },
    {
      path: '/:lang/webshop/product-selection',
      name: 'ProductSelectionIndex',
      component: ProductSelection,
      beforeEnter: async function (to, from, next) {
        await overrideFromWebsiteCookie()
        if (store.getters['selection/availableSelectedRegions'].length > 0) {
          next({name: 'ProductOverview', params: to.params})
        } else {
          next({name: 'RegionSelect', params: to.params})
        }
      }
    },
    {
      path: '/:lang/:sale(special\\-sale|verlengregeling)/:slug',
      name: 'SpecialSale',
      component: SpecialSale
    },
    {
      path: '/winkelmand',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/:lang/webshop/payment',
      name: 'Payment',
      component: Payment,
      beforeEnter: function (to, from, next) {
        if (!store.state.cart.priceSpecification) {
          next({name: 'ProductOverview', params: to.params})
        }
        next()
      }
    },
    {
      path: '/:lang/webshop/payment/checkout',
      name: 'PaymentSelection',
      component: PaymentSelection
    },
    {
      path: '/:lang/webshop/payment/status',
      name: 'PaymentStatus',
      component: PaymentStatus
    },
    {
      path: '/:lang/webshop/payment/result',
      name: 'PaymentConfirmation',
      component: PaymentConfirmation,
      beforeEnter: async function (to, from, next) {
        if (!store.state.cart.orderStatus) {
          next({name: 'ProductOverview', params: to.params})
        } else {
          next()
        }
      }
    },
    {
      path: '/:lang/webshop/store-user/login',
      name: 'StoreUserLogin',
      component: StoreUserLogin,
      props: {
        bodyClass: []
      }
    },
    {
      path: '/:lang/webshop/store-user/set-password/token/:token',
      name: 'StoreUserChangePassword',
      component: StoreUserChangePassword,
      props: {
        bodyClass: []
      }
    },
    {
      path: '/login',
      redirect: {name: 'StoreUserLogin', params: {lang: 'nl'}}
    },
    ...buildAbtRoutes(store, subscriptionManager),
    {
      path: '/*',
      redirect: {name: 'ProductSelectionIndex', params: {lang: 'nl'}}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/routes/index.js